import React, { useState } from "react";

const Search = React.forwardRef((props, ref) => {
    console.log(props)
    const [input_value, SetValue] = useState("");
    let style={}
    if(props.style !== undefined){
        style=props.style;
    }

    return(
        <div className="col-12 correcao-search-column">
        {props.children?props.children:''}
        <div className={'correcao-search-box '+(props.className || '')} style={{...style}}>
            <i className="mdi mdi-magnify"></i>
            <input
                ref={ref}
                placeholder={props.placeholder} 
                value={input_value}
                className="correcao-search-input"
                onChange={(e) => {
                    SetValue(e.target.value);
                    if (!props.WaitConfirm) (props.ValueChange && props.ValueChange(e.target.value));
                }}
            />
            <button
                type="button"
                className="correcao-search-button"
                onClick={() => (props.ValueChange && props.ValueChange(input_value))}
            >
                {props.buttonText || 'Buscar'}
            </button>
        </div>
        </div>

    );
});

export default Search;
